import axios from 'axios';

const khonsu = axios.create({
    baseURL: process.env.REACT_APP_KHONSU,
});

export default khonsu;